import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  get_assessment_kit_details_action,
  accept_assessment_kit_action,
  decline_assessment_kit_action,
} from "../../../redux/_actions";
import { appRoutes } from "../../../_routes/app-routes";
import { AuthContext } from "../../../_hooks/useAuthContext";

function usePublicAssessmentDetails(props) {
  const { user } = useContext(AuthContext);

  const [assessmentDetails, setAssessmentDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [isAcceptLoading, setIsAcceptLoading] = useState(false);
  const [declineAssessmentModal, setDeclineAssessmentModal] = useState(false);
  const [declineLoading, setDeclineLoading] = useState(false);
  const [userData, setUserData] = useState(null);

  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();

  const { assessmentKitDetailsData } = useSelector(
    (state) => state.get_assessment_kit_details_reducer
  );

  useEffect(() => {
    if (user) {
      setUserData(user?.user);
    }
  }, [user]);

  useEffect(() => {
    let id = params?.id;
    if (id) {
      callApi(id);
    }
  }, []);

  useEffect(() => {
    if (assessmentKitDetailsData) {
      setAssessmentDetails(assessmentKitDetailsData);
    }
  }, [assessmentKitDetailsData]);

  const callApi = async (id) => {
    setLoading(true);
    await dispatch(get_assessment_kit_details_action(id));
    setLoading(false);
  };

  const onLoginClick = async () => {
    navigate("/sign-in", {
      state: {
        navigateRoute: appRoutes.assessementKit.assessmentPublicDetails.replace(
          ":id",
          assessmentDetails?.hash_id
        ),
      },
    });
  };

  const onAcceptAssessment = async (id) => {
    setIsAcceptLoading(true);
    let res = await dispatch(accept_assessment_kit_action(id));
    if (res?.id) {
      navigate(
        appRoutes.assessementKit.previewAssessment.replace(
          ":assignedAssessmentId",
          res?.id
        )
      );
    }
    setIsAcceptLoading(false);
  };

  const onDeclineAssessmentClick = async () => {
    const id =
      assessmentDetails?.assigned_assessment_details &&
      assessmentDetails?.assigned_assessment_details?.id;
    setDeclineLoading(true);
    const res = await dispatch(decline_assessment_kit_action(id));
    if (res?.id) {
      setDeclineLoading(false);
      navigate(appRoutes.assessementKit.candidateAssignedAssessments);
    }
    setDeclineLoading(false);
  };

  const handleIsDeclineModal = () => {
    setDeclineAssessmentModal((v) => !v);
  };

  const onStartAssessmentClick = async (id) => {
    navigate(
      appRoutes.assessementKit.previewAssessment.replace(
        ":assignedAssessmentId",
        id
      )
    );
  };

  return {
    userData,
    assessmentDetails,
    isAcceptLoading,
    loading,
    declineAssessmentModal,
    declineLoading,
    handleIsDeclineModal,
    onAcceptAssessment,
    onLoginClick,
    onDeclineAssessmentClick,
    onStartAssessmentClick,
  };
}
export default usePublicAssessmentDetails;
